<template>
  <div class="border-box-container">
    <slot></slot>
    <div class="bg-layer"></div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.border-box-container {
  position: relative;

  background: url('~@/assets/image/monitor/clip-bg.png') no-repeat 0 0 / 100% 100%;

  .bg-layer {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 999;

    pointer-events: none;

    width: 100%;
    height: 100%;

    background: url('~@/assets/image/monitor/kuang.png') no-repeat 0 0 / 100% 100%;
  }
}
</style>
